import { API, graphqlOperation } from "aws-amplify";
import * as subscriptions from "../../graphql/subscriptions";

class InviteLogSubscription {
  /*
    Task: Get InviteLog subscription on create from amplify graphql
  */
  static getOnCreate() {
    return API.graphql({
      ...graphqlOperation(subscriptions.onCreateInviteLog),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as any;
  }

  /*
    Task: Get InviteLog subscription on update from amplify graphql
  */
  static getOnUpdate() {
    return API.graphql({
      ...graphqlOperation(subscriptions.onUpdateInviteLog),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as any;
  }

  /*
    Task: Get InviteLog subscription on delete from amplify graphql
  */
  static getOnDelete() {
    return API.graphql({
      ...graphqlOperation(subscriptions.onDeleteInviteLog),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as any;
  }
}

export { InviteLogSubscription };
